import styles from './FilterSelectDialog.module.css'
import { ClickAwayListener, Dialog, IconButton, Popper } from '@mui/material'
import { useBreakpointUp } from 'shared/hooks/useBreakpointQueries'
import { BedroomsFilterContainer } from './containers/BedroomsFilterContainer'
import { BedsFilterContainer } from './containers/BedsFilterContainer'
import { PetsFilterContainer } from './containers/PetsFilterContainer'
import { useEffect, useState } from 'react'
import { ApplyButton } from './presentations/ApplyButton'
import CloseIcon from '@mui/icons-material/Close'
import { ClearAllButton } from './presentations/ClearAllButton'

interface FilterSelectDialogProps {
    open: boolean
    filters: any
    onOpen?: (event: any) => void
    onClose?: (event: any) => void
    onFiltersChange?: (event: any) => void
    onOk?: (event: any) => void
    onCancel?: (event: any) => void
}

const defaultFilters =  {
        bedrooms: [],
        beds: [],
        pets: []
    }

export const FilterSelectDialog = (props: FilterSelectDialogProps): JSX.Element => {
    const {
        open,
        filters,
        onOpen,
        onClose,
        onFiltersChange,
        onOk,
        onCancel,
    } = props
 
    const [openSelectors, setOpenSelectors] = useState({
        bedrooms: false,
        beds: false,
        pets: false,
    })

    const [innerfilter, setInnerFilter] = useState<any>(filters || defaultFilters)

    const isXlWidthScreenOrMore = useBreakpointUp('xl')

    const handleFilterSelectorOpen = (event: any) => {
        setOpenSelectors({
            bedrooms: false,
            beds: false,
            pets: false,
            [event]: true
        })
    }

    const handleFilterSelectorClose = (event: any) => {
        setOpenSelectors({
            bedrooms: false,
            beds: false,
            pets: false,
        })
    }

    const anchorVirtualElement: any = {
        getBoundingClientRect: () => {
            return {
                width: window.innerWidth,
                height: 0,
                top: 90,
                right: 0,
                bottom: 0,
                left: 0,
            }
        },
    }

    const handleSelectedItemsChanged = (event: any) => {
        setInnerFilter({
            ...innerfilter,
            [event.propertyName]: event.selectedItems
        })
    } 

    const handleClearAllButtonClick = (event: any) => {
        setOpenSelectors({
            bedrooms: false,
            beds: false,
            pets: false,
        })

        const newFilter = {
            bedrooms: ['1+'],
            beds: ['1+'],
            pets: ['1+']
        }

        setInnerFilter?.(newFilter)
    }

    const handleDialogClose = (event: any) => {
        onClose?.(event)
    }

    const handleClickAwayListenerClickAway = (event: any) => {
        onClose?.(event)
    }

    const handleApplyButtonClick = (event: any) => {
        setOpenSelectors({
            bedrooms: false,
            beds: false,
            pets: false,
        })
        onFiltersChange?.(innerfilter)
        onClose?.(event)
    }

    useEffect(() => {
        if (open === false){
            setOpenSelectors({
                bedrooms: false,
                beds: false,
                pets: false,
            })
        }       
    }, [
        open
    ])

    if (isXlWidthScreenOrMore) {
        const popperOptions: any = {
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 10],
                    },
                },
            ]
        }

        return (
            <Popper
                className={styles.Popper}
                open={open}
                anchorEl={anchorVirtualElement}
                popperOptions={popperOptions}
            >
                <ClickAwayListener 
                    onClickAway={handleClickAwayListenerClickAway}
                >
                    <div className={styles.Popper__FilterListContainer}>
                        <BedroomsFilterContainer
                            open={openSelectors[`bedrooms`]}
                            propertyName={`bedrooms`}
                            initialSelectedItems={innerfilter[`bedrooms`]}
                            onOpen={handleFilterSelectorOpen}
                            onClose={handleFilterSelectorClose}
                            onSelectedItemsChanged={handleSelectedItemsChanged}

                        />
                        <BedsFilterContainer
                            open={openSelectors[`beds`]}
                            propertyName={`beds`}
                            initialSelectedItems={innerfilter[`beds`]}
                            onOpen={handleFilterSelectorOpen}
                            onClose={handleFilterSelectorClose}
                            onSelectedItemsChanged={handleSelectedItemsChanged}
                        />
                        <PetsFilterContainer
                            open={openSelectors[`pets`]}
                            propertyName={`pets`}
                            initialSelectedItems={innerfilter[`pets`]}
                            onOpen={handleFilterSelectorOpen}
                            onClose={handleFilterSelectorClose}
                            onSelectedItemsChanged={handleSelectedItemsChanged}
                        />
                        <div className={styles.Popper__EndContainer}>
                            <ClearAllButton 
                                onClick={handleClearAllButtonClick}
                            />
                            <ApplyButton 
                                onClick={handleApplyButtonClick}
                            />
                        </div>
                    </div>
                </ClickAwayListener>
            </Popper>
        )
    }

    return (
        <Dialog
            onClose={handleDialogClose}
            open={open}
            fullScreen
        >
            <div className={styles.Dialog__Content}>
                <div className={styles.Dialog__StartContainer}>
                    <div></div>
                    <div className={styles.Dialog__TitleContainer}>
                        <div className={styles.Dialog__Title}>Filters</div>
                    </div>
                    <div>
                        <IconButton
                            className={styles.CloseSearchButton}
                            aria-label=""
                            size="small"
                            onClick={handleDialogClose}
                        >
                            <CloseIcon
                                className={styles.CloseSearchButton__Icon}
                            />
                        </IconButton>
                    </div>
                </div>
                <div className={styles.Dialog__CenterContainer}>
                    <div className={styles.Dialog__FilterListContainer}>
                        <BedroomsFilterContainer
                            open={openSelectors[`bedrooms`]}
                            propertyName={`bedrooms`}
                            initialSelectedItems={innerfilter[`bedrooms`]}
                            onOpen={handleFilterSelectorOpen}
                            onClose={handleFilterSelectorClose}
                            onSelectedItemsChanged={handleSelectedItemsChanged}

                        />
                        <BedsFilterContainer
                            open={openSelectors[`beds`]}
                            propertyName={`beds`}
                            initialSelectedItems={innerfilter[`beds`]}
                            onOpen={handleFilterSelectorOpen}
                            onClose={handleFilterSelectorClose}
                            onSelectedItemsChanged={handleSelectedItemsChanged}
                        />
                        <PetsFilterContainer
                            open={openSelectors[`pets`]}
                            propertyName={`pets`}
                            initialSelectedItems={innerfilter[`pets`]}
                            onOpen={handleFilterSelectorOpen}
                            onClose={handleFilterSelectorClose}
                            onSelectedItemsChanged={handleSelectedItemsChanged}
                        />
                    </div>
                </div>
                <div className={styles.Dialog__EndContainer}>
                    <ClearAllButton 
                        onClick={handleClearAllButtonClick}
                    />
                    <ApplyButton />
                </div>
            </div>   
        </Dialog>
    )
}